var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.439 221.112c0 5.648-4.576 10.275-10.184 9.757a110.748 110.748 0 01-32.306-8.006 111.001 111.001 0 01-36.02-24.135 111.344 111.344 0 01-24.069-36.121 111.61 111.61 0 010-85.215 111.361 111.361 0 0124.069-36.12 111.011 111.011 0 0136.02-24.136 110.778 110.778 0 0132.306-8.006c5.608-.518 10.184 4.11 10.184 9.757v47.849c-29.336 0-53.117 23.847-53.117 53.264s23.78 53.264 53.116 53.265V66.736c29.335 0 53.116 23.847 53.116 53.264s-23.78 53.264-53.115 53.265v47.847z",
    fill: "#38318B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.32 173.236l-.002-106.472c29.402 0 53.237 23.834 53.237 53.236 0 29.401-23.834 53.236-53.235 53.236z",
    fill: "#DF6552"
  })));
}
export default SvgLogo;